export const DEFAULT_TYPE = 0;
export const CUSTOM_ANCHORS = 1;
